import { useEffect, useState } from 'react';

const useIsTextInDOM = (targetText: string): boolean => {
  const [isTextVisible, setIsTextVisible] = useState(false);

  useEffect(() => {
    const observer = new MutationObserver((mutationsList: MutationRecord[]) => {
      for (const mutation of mutationsList) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            const textNode = node as Text;
            if (textNode.textContent?.includes(targetText)) {
              setIsTextVisible(true);
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            const elementNode = node as HTMLElement;
            const elementText =
              elementNode.innerText || elementNode.textContent;
            if (elementText?.includes(targetText)) {
              setIsTextVisible(true);
            }
          }
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, [targetText]);

  return isTextVisible;
};

export default useIsTextInDOM;
